(function () {
    'use strict';

    angular
        .module('vm')
        .factory('SignUpMay19Service', SignUpMay19Service);

    function SignUpMay19Service (
        localStorageService, 
        signUpMay19Config, 
        $location, 
        $api, 
        CONFIG, 
        ResponsiveService,
        DomainSettingsService,
        MetricsDataService
    ) {
        const localStorageKey = 'sign-up-may-19-step-answers';

        return {
            saveStepAnswer: saveStepAnswer,
            getStepAnswer: getStepAnswer,
            goToNextStep: goToNextStep,
            sendSignUpForm: sendSignUpForm,
            removeAnswers: removeAnswers,
            getSignUpFormData: getSignUpFormData,
            addPageLeaveListener: addPageLeaveListener,
            removePageLeaveListener: removePageLeaveListener,
            getSteps: getSteps,
        };

        //////////////

        function saveStepAnswer(stepType, answer) {
            const stepAnswers = getStepAnswers();

            stepAnswers[stepType] = answer;

            localStorageService.set(localStorageKey, stepAnswers);
        }

        function goToNextStep(currentStep) {
            getSteps()
                .then((steps) => {
                    for (const step of steps) {
                        if (step.type === currentStep) {
                            const nextStep = steps[steps.indexOf(step) + 1];
        
                            if (nextStep) {
                                $location.search('step', nextStep.type);
                                break;
                            }
                        }
                    }
                })
            ;
        }

        function sendSignUpForm() {
            return getSignUpFormData()
                .then((formData) => {
                    const data = {
                        api_signup_by_group: formData,
                    };
        
                    return $api.post('account/signup-by-group', data);
                })
            ;
        }

        function getSignUpFormData() {
            return isSmsVerificationEnabled()
                .then((smsVerificationEnabled) => {
                    const formData = {};

                    const answers = getStepAnswers();
        
                    if (smsVerificationEnabled && answers.gender.sex === 'female') {
                        formData.group = 'new_signup_may19_female';
                    } else {
                        formData.group = 'new_signup_may19';
                    }
        
                    formData.name = answers.username.username;
                    formData.email = answers.email.email;
                    formData.sex = answers.gender.sex;
                    formData.seekingSex = answers.gender.seekingSex;
                    formData.relationshipStatus = answers.relationship_status;
                    formData.password = answers.password.password;
                    formData.birthDate = moment(answers.birthday, 'DD.MM.YYYY').format('YYYY-MM-DD');
                    formData.agreeWithTerms = answers.acceptTerms.agreeWithTerms;
                    formData.agreeWithEmailMarketing = answers.email.agreeWithEmailMarketing;
                    formData.height = answers.height;
                    formData.weight = answers.weight;
                    formData.eyes = answers.eyes;
                    formData.hair = answers.hair;
                    formData.bodyType = answers.body_type;
                    formData.looks = answers.looks;
                    formData.city_id = answers.location.id;
        
                    if (answers.phone) {
                        formData.phoneNumber = answers.phone.phoneNumber;
                    }
        
                    let campaign = answers.organic;
        
                    if (campaign === 'non_brand') {
                        campaign = 'nonbrand';
                    }
        
                    formData.registerCampaignId = campaign;
        
                    return formData;
                })
            ;
        }

        function getStepAnswer(stepType) {
            const stepAnswers = getStepAnswers();

            return stepAnswers[stepType];
        }

        function getStepAnswers() {
            let stepAnswers = localStorageService.get(localStorageKey);

            if (!stepAnswers) {
                stepAnswers = {}; 
            }

            return stepAnswers;
        }

        function removeAnswers() {
            localStorageService.remove(localStorageKey);
        }

        function addPageLeaveListener() {
            window.addEventListener('beforeunload', onPageLeave);
        }

        function removePageLeaveListener() {
            window.removeEventListener('beforeunload', onPageLeave);
        }

        function onPageLeave(event) {
            event.preventDefault();
            event.returnValue = '';
        }

        function getSteps() {
            return isSmsVerificationEnabled()
                .then((verificationEnabled) => {
                    return signUpMay19Config.steps
                        .filter((step) => {
                            if (CONFIG.project === 'vm' && !ResponsiveService.isMobile()) {
                                if (step.type === 'gender' || step.type === 'relationship_status') {
                                    return false;
                                }
                            }
        
                            return true;
                        })
                        .filter((step) => {
                            if (step.type === 'phone' || step.type === 'sms-verification') {
                                if (verificationEnabled) {
                                    const genderAnswer = getStepAnswer('gender');
        
                                    if (genderAnswer && genderAnswer.sex === 'female') {
                                        return true;
                                    }
                                }
        
                                return false;
                            }
        
                            return true;
                        })
                        .filter((step) => {
                            if (step.type === 'organic') {
                                if (MetricsDataService.getCampaign() !== 'organic') {
                                    return false;
                                }
                            }

                            return true;
                        })
                    ;
                })
            ;
        }

        function isSmsVerificationEnabled() {
            return DomainSettingsService.get()
                .then((domainSettings) => {
                    return (
                        CONFIG.smsVerificationDomains && 
                        (
                            CONFIG.smsVerificationDomains.indexOf(domainSettings.ipCountryCode) !== -1 ||
                            CONFIG.smsVerificationDomains.indexOf('ALL') !== -1
                        )
                    );
                })
            ;
        }
    }
}());